import React, { useContext, useEffect, useState } from "react";
import "./Popular_Product.css";
import { useNavigate } from "react-router-dom";
import Common_Product_Card from "../../Common-Component/common_product_card/Common_Product_Card";
import { Context } from "../../../utils/context";
import { popularProduct } from "../../../utils/apis/Product/Product";

const Popular_Product = () => {
  const { IMG_URL, shimmerLoader, setShimmerLoader,currentLocation } = useContext(Context);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const getProduct = async () => {
      const city =
      currentLocation?.city ||currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    setShimmerLoader(true);
    try {
      const res = await popularProduct(city);

      if (res?.success) {
        setProducts(res?.data);
      }
    } catch (error) {
      console.error("Error fetching popular products:", error);
    } finally {
      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getProduct();
  }, [currentLocation]);

  return (
    <section className="Popular_Product">
      <div className="heading_div">
        <p className="card_title">Popular Product</p>
      </div>

      <section className="Product_Card">
        {shimmerLoader ? (
          <p>Loading popular products...</p>
        ) : products.length > 0 ? (
          products.map((item) => (
            <Common_Product_Card
              key={item.id}
              imgsrc={IMG_URL + item.image1}
              prodTitle={item.name}
              price={item.product_variants?.[0]?.s_price}
              id={item.id}
            />
          ))
        ) : (
          <p>No popular products found.</p>
        )}
      </section>
    </section>
  );
};

export default Popular_Product;
